'use client';

import { Tab } from '@common/components';

import { ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';

import { MERCHANT_TAB, type MerchantTab } from '../_constants';

interface MerchantTabsProps {
  activeTab: MerchantTab;
}

export const MerchantTabs = ({ activeTab }: MerchantTabsProps) => {
  const router = useCustomRouter();

  const handleChange = (tab: string) => {
    router.replace(
      ROUTES.BENEFIT_MERCHANTS.withSearchParams({
        searchParams: { tab: tab as MerchantTab },
      }),
      { scroll: false },
    );
  };

  return (
    <Tab value={activeTab} onChange={handleChange}>
      <Tab.Item value={MERCHANT_TAB.BRAND}>제휴몰</Tab.Item>
      <Tab.Item value={MERCHANT_TAB.PRODUCT}>상품</Tab.Item>
    </Tab>
  );
};
